import { Link } from "@nike/nike-design-system-icons";
import { IconButton, Tooltip } from "@nike/eds";
import { useState } from "react";

// a copy to clipboard button that takes a url as a prop
export function ShortcutLink({ url, size, className }: { url: string, size?: "small" | "medium" | "large", className?: string }) {
  const [copied, setCopied] = useState(false);
  const fullUrl = window.location.origin + url;

  const handleCopy = () => {
    navigator.clipboard.writeText(fullUrl);
    setCopied(true);
    
    // Reset back to "Copy link" after 2 seconds
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <Tooltip bodySlot={copied ? "Copied!" : "Copy link"}>
      <IconButton className={className} icon={<Link />} size={size} label="Copy Link to Clipboard" onClick={handleCopy} />
    </Tooltip>
  );
}